export default {
  'Screenshot': '截图',
}